import moment from "moment";
import achievementImg from "../../../assets/images/training/achivement.png";
import { Link } from "react-router-dom";
import { RATING_TYPES } from "../../../constants";
function AchievementCard({ achievement }: { achievement: any }) {
  return (
    <div className="achievement">
      {achievement?.certificateNo ? <Link to={`/training/endorsement/view/${achievement?._id}`}>
        <img src={achievementImg} alt="" />
        <div className="circle"></div>
        <h4 className="title">{achievement?.name?.substring(0, 30)}</h4>
        {achievement?.updatedAt && <div className="date">Level achieved {moment(achievement?.updatedAt).format("DD/MM/YYYY")}</div>}
      </Link> : <>
        <img src={achievementImg} alt="" />
        <div className="circle"></div>
        <h4 className="title">{RATING_TYPES[achievement?.ratingType]['label']} ({RATING_TYPES[achievement?.ratingType]['models'][achievement?.ratingModal]})</h4>
        {achievement?.updatedAt && <div className="date">Level achieved {moment(achievement?.updatedAt).format("DD/MM/YYYY")}</div>}
      </>}

    </div>
  );
}

export default AchievementCard;
